import { Directive, Input, TemplateRef } from '@angular/core'

/**
 * Structural directive that registers a custom cell template for a
 * specific column id on `<app-detail-table>`.
 *
 * Usage:
 *
 *     <app-detail-table [config]="cfg" [rows]="rows">
 *       <ng-container *detailTableCell="'station'; let row">
 *         <strong>{{ row.station_name }}</strong>
 *       </ng-container>
 *     </app-detail-table>
 *
 * The `let row` context exposes the row instance; `let column =
 * column` exposes the column descriptor. The directive's template is
 * picked up by the table via `@ContentChildren`.
 */
@Directive({
    selector: '[detailTableCell]',
    standalone: true
})
export class DetailTableCellDirective<T = unknown> {
    /** Column id whose body cells should render this template. */
    @Input('detailTableCell') columnId!: string

    constructor(public template: TemplateRef<{ $implicit: T; column: unknown }>) {}

    /** Type-checking helper — see https://angular.dev/guide/structural-directives. */
    static ngTemplateContextGuard<T>(
        _dir: DetailTableCellDirective<T>,
        ctx: unknown
    ): ctx is { $implicit: T; column: unknown } {
        return true
    }
}
